module.exports = __webpack_public_path__ + "assets/img/tab-active-img-feature3-2b8662b0.png";